module.exports = __webpack_public_path__ + "img/loader.8b67d03e.gif";